export default __webpack_public_path__ + "static/media/acumen-demo.d1ac81b5.mp4";